import { BaseMaskAdapter } from "./base-adapter";

export class NumberPresetAdapter extends BaseMaskAdapter {
  constructor() {
    super("");
  }

  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
  }

  parseFromInput(inputValue: string): { value: number; formatted: string } {
    const digits = this.cleanNumericInput(inputValue);
    if (!digits) {
      return { value: 0, formatted: "" };
    }

    const numericValue = Number(digits);
    return {
      value: numericValue,
      formatted: numericValue.toLocaleString("pt-BR", { maximumFractionDigits: 0 }),
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    return /^\d$/.test(key);
  }
}
